var l = /* @__PURE__ */ ((o) => (o.ID = "id", o.ROLE = "role", o.MINUSROLE = "-role", o))(l || {});
export {
  l as SearchOrderEnum
};
